import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  // {
  //   path: "/home",
  //   name: "home",
  //   component: HomeView,
  // },
  {
    path: "/gameInfo",
    name: "gameInfo",
    component: () => import("../views/gameInfo.vue"),
  },
  {
    path: "/game/:name/:id",
    name: "game",
    component: () => import("../views/game.vue"),
  },
  {
    path: "/wall",
    name: "wall",
    component: () => import("../views/wall.vue"),
  },
  {
    path: "/userCenter",
    name: "userCenter",
    component: () => import("../views/userCenter.vue"),
  },
  {
    path: "/otherCenter",
    name: "otherCenter",
    component: () => import("../views/otherCenter.vue"),
  },
  {
    path: "/dataBaseSubmit",
    name: "dataBaseSubmit",
    component: () => import("../views/dataBaseSubmit.vue"),
  },
  {
    path: "/applyGame",
    name: "applyGame",
    component: () => import("../views/applyGame.vue"),
  },
  {
    path: "/community/:id",
    name: "community",
    component: () => import("../views/community.vue"),
  },
  {
    path: "/gameLive",
    name: "gameLive",
    component: () => import("../views/gameLive.vue"),
  },
  {
    path: "/ai",
    name: "ai",
    component: () => import("../views/ai.vue"),
  },
  {
    path: "/userFollowing",
    name: "userFollowing",
    component: () => import("../views/userFollowing.vue"),
  },
  {
    path: "/creator",
    name: "creator",
    component: () => import("../views/creator.vue"),
  },
  {
    path: "/events",
    name: "events",
    component: () => import("../views/events.vue"),
  },
  {
    path: "/demo",
    name: "demo",
    component: () => import("../views/demo.vue"),
  },
];

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes,
});

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  // 检查用户是否已登录
  next()
});
export default router;
